/* Fit tiles in MD Outfits jeans collections. A product has one fit: a fit in
   its title takes precedence; otherwise use the dedicated Fit metafield/tag. */
(() => {
  const names = {skinny:'Skinny',slim:'Slim',straight:'Straight','wide-leg':'Wide Leg',baggy:'Baggy',bootcut:'Bootcut',flared:'Flared'};
  const normalize = value => String(value || '').toLowerCase().trim().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
  const fitFromText = text => {
    const value = normalize(text);
    if (/(^|\W)boot\s*cut(\W|$)/.test(value)) return 'bootcut';
    if (/(^|\W)wide\s*leg(\W|$)/.test(value)) return 'wide-leg';
    if (/(^|\W)skinny(\W|$)/.test(value)) return 'skinny';
    if (/(^|\W)slim(\W|$)/.test(value)) return 'slim';
    if (/(^|\W)straight(\W|$)/.test(value)) return 'straight';
    if (/(^|\W)baggy(\W|$)/.test(value)) return 'baggy';
    if (/(^|\W)flar(?:e|ed)(\W|$)/.test(value)) return 'flared';
    return null;
  };
  const productFit = item => {
    const title = normalize(item.dataset.mdFitTitle);
    const explicitTitleFit = fitFromText(title);
    if (explicitTitleFit) return explicitTitleFit;
    // 'Mom fit' and trousers cannot be silently assigned to another jeans fit.
    if (/\bmom\s*fit\b|\btrouser\b/.test(title)) return null;
    const meta = normalize(item.dataset.mdFitMeta);
    const metaFits = [...new Set(meta.split(/[,|/;]/).map(fitFromText).filter(Boolean))];
    if (metaFits.length === 1) return metaFits[0];
    if (metaFits.length > 1) return null;
    const tags = String(item.dataset.mdFitTags || '').split('|');
    const dedicated = tags.map(tag => /^\s*fit\s*[:=_-]\s*(.+)\s*$/i.exec(tag)?.[1]).filter(Boolean);
    const unique = [...new Set(dedicated.map(fitFromText).filter(Boolean))];
    return unique.length === 1 ? unique[0] : null;
  };
  const update = () => {
    const fit = fitFromText(new URLSearchParams(location.search).get('md_fit'));
    if (!names[fit]) return;
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    let count = 0;
    grid.querySelectorAll(':scope > li[data-md-fit-title]').forEach(item => {
      const show = productFit(item) === fit;
      item.hidden = !show;
      if (show) count++;
    });
    const empty = document.getElementById('md-fit-empty');
    if (empty) empty.hidden = count !== 0;
    document.querySelectorAll('.md-fit-card').forEach(card => {
      const active = fitFromText(card.querySelector('.md-fit-name')?.textContent) === fit;
      card.classList.toggle('md-fit-card--active', active);
      if (active) card.setAttribute('aria-current', 'page'); else card.removeAttribute('aria-current');
    });
    const pagination = document.querySelector('#ProductGridContainer .pagination-wrapper');
    if (pagination) pagination.hidden = true;
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(label => {
      label.textContent = count + ' ' + (count === 1 ? 'product' : 'products');
    });
  };
  document.addEventListener('click', event => {
    const option = event.target.closest('#MD-Fit-Panel [data-md-fit]');
    if (!option) return;
    event.preventDefault();
    const fit = fitFromText(option.dataset.mdFit);
    const tile = [...document.querySelectorAll('.md-fit-card')].find(card => fitFromText(card.querySelector('.md-fit-name')?.textContent) === fit);
    if (tile) location.href = tile.href;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
})();
